<form [formGroup]="selectedDateForm">
  <p-sidebar
    [(visible)]="visible"
    position="right"
    styleClass="w-screen lg:w-4"
    (onShow)="onShow()"
  >
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2">
        <span class="font-bold text-lg">
          Seleccione una fecha de entrega
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="flex flex-column field p-0 gap-3">
        @for(item of availableDates; track $index){
        <div
          class="flex p-3 border-round border-1 surface-border w-full cursor-pointer flex align-items-center h-5rem md:h-6rem"
          (click)="onSelectDate(item.index)"
          [ngClass]="{
            'surface-border hover:border-400':
              indexField?.value !== item.index,
            'border-primary bg-blue-50': indexField?.value === item.index
          }"
        >
          <p-radioButton
            name="index"
            [value]="item.index"
            formControlName="index"
            styleClass="mr-3"
          />
          <div class="mr-4 md:mr-6">
            <div class="font-semibold mb-1 capitalize-first-letter">
              {{ item.fecha | shippingDate }}
            </div>
            <span class="text-sm">{{
              item.precio ? (item.precio | currency) : 'Gratis'
            }}</span>
          </div>
        </div>
        }
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <p-button
          label="Seleccionar"
          class="w-full"
          styleClass="w-full"
          (onClick)="submit()"
        />
      </div>
    </ng-template>
  </p-sidebar>
</form>
